import badWord from 'bad-words'
import ApiService from '../../common/ApiCalls'
import { englishTexts as words } from '../../consts/Texts'
const filter = new badWord()
export const isEmpty = (str) => {
  if (str) {
    return str.trim().length === 0
  } else {
    return true
  }
}

export const checkLength = (str, len) => {
  return str.length > len
}

/**
 * Checks if given string is valid HTTP URL
 * @param link string to check if it is a link
 * @returns {boolean} returns true if is a link
 */
export const isLink = (link) => {
  let url
  try {
    url = new URL(link)
  } catch (_) {
    return false
  }
  return url.protocol === 'http:' || url.protocol === 'https:'
}

/**
 * Checks if a string contains profane language
 * @param text input to check
 * @returns {boolean}
 */
export const containsProfane = (text) => {
  return filter.isProfane(text)
}

/**
 * Checks if a string contains special character
 * @param text input to check
 * @returns {boolean}
 */
export const containsSpecialChar = (text) => {
  const specialChars = /[!@$%^*()_+=[\]{};':"\\|<>?]/
  return text.match(specialChars)
}

export const validateFirstName = (firstName) => {
  if (containsProfane(firstName)) return 'Text includes profane words.'
  if (checkLength(firstName, 20)) return 'Maximum of 20 characters.'
  if (isEmpty(firstName)) return 'Name cannot be empty.'
  return false
}

export const validateLastName = (lastName) => {
  if (containsProfane(lastName)) return 'Text includes profane words.'
  if (lastName === null) return false
  if (checkLength(lastName, 40)) return 'Maximum of 40 characters.'
  if (isEmpty(lastName)) return 'Name cannot be empty.'
  return false
}

export const validatePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return false
  if (!phoneNumber.length) return false
  const phoneNumberNoDash = phoneNumber.replace(/[^0-9]/g, '')
  if (phoneNumberNoDash.length < 10) return 'Invalid Phone Number'
  return false
}

export const validateEmail = (email) => {
  if (!email) return false
  if (!email.length) return false
  if (!email.match(/.+@.+\..+/)) return 'Invalid Email Address'
  return false
}

export const validateRequiredEmail = (email) => {
  if (isEmpty(email)) return 'Email cannot be empty.'
  if (!email.length) return false
  if (!email.match(/.+@.+\..+/)) return 'Invalid Email Address'
  return false
}

export const validateDescription = (description) => {
  if (description === null) return false
  if (checkLength(description, 255)) return 'Maximum of 255 characters.'
  if (containsProfane(description)) return 'Text includes profane words.'
  return false
}

export const validateRecordType = (recordType) => {
  if (!recordType) return 'Select a record type'
  return false
}

export const validateRecordName = (recordName) => {
  if (recordName === null) return false
  if (containsProfane(recordName)) return 'Text includes profane words.'
  if (isEmpty(recordName)) return 'Name cannot be empty.'
  if (checkLength(recordName, 150)) return 'Maximum of 150 characters.'
  return false
}

export const validateRecordURL = (recordURL) => {
  if (!recordURL) return 'URL cannot be empty.'
  if (!isLink(recordURL)) return 'Invalid URL. It has to be https or http format.'
  return false
}

export const validateOptionalRecordURL = (recordURL) => {
  if (!recordURL) return false
  if (!isLink(recordURL)) return 'Invalid URL. It has to be https or http format.'
  return false
}

// export const validateCompleteDate = (completeDate) => {
//     if(!Boolean(completeDate)) return "Select a date"
//     return false
// }

export const validateBuildingID = (originalBuildingID, buildingID, firstAvailableNumStr, lastAvailableNumStr) => {
  const firstAvailableNum = parseInt(firstAvailableNumStr)
  const lastAvailableNum = parseInt(lastAvailableNumStr)

  if (buildingID === null) return false
  if (isEmpty(buildingID)) return 'Building ID cannot be empty.'
  if (buildingID < 0) return 'Building ID cannot be negative.'
  if (isNaN(buildingID)) return 'Type only number'

  if (originalBuildingID !== parseInt(buildingID)) {
    if (firstAvailableNum !== -1 && lastAvailableNum !== -1 &&
            parseInt(buildingID) !== firstAvailableNum && parseInt(buildingID) !== lastAvailableNum) {
      return `Available ID is either ${firstAvailableNum} or ${lastAvailableNum}`
    }
    if (firstAvailableNum === -1 && parseInt(buildingID) !== lastAvailableNum) return `Available ID is ${lastAvailableNum}`
    if (lastAvailableNum === -1 && parseInt(buildingID) !== firstAvailableNum) return `Available ID is ${firstAvailableNum}`
  }

  return false
}

export const validateBuildingName = (buildingName) => {
  if (buildingName === null) return false
  if (checkLength(buildingName, 50)) return 'Maximum of 50 characters.'
  if (isEmpty(buildingName)) return 'Building name cannot be empty.'
  if (containsProfane(buildingName)) return 'Text includes profane words.'
  if (containsSpecialChar(buildingName)) return "Building name cannot have special characters (!@$%^*()_+=[]{};':\"|<>?)"
  if (buildingName.replace(/ /g, '').length < 3) return 'Building name has to be at least 3 characters.'

  return false
}

export const duplicateCheckBuildingName = async (buildingName, province) => {
  const data = {
    searchInput: buildingName,
    province
  }
  const searchResult = await ApiService().searchBuildingByProvince(data)

  return searchResult.length > 0 && searchResult[0].name === buildingName
}

export const validateTransitName = (transitName) => {
  if (transitName === null) return false
  if (checkLength(transitName, 80)) return 'Maximum of 80 characters.'
  if (isEmpty(transitName)) return 'Transit name cannot be empty.'
  if (containsProfane(transitName)) return 'Text includes profane words.'
  if (containsSpecialChar(transitName)) return "Transit name cannot have special characters (!@$%^*()_+=[]{};':\"|<>?)"
  if (transitName.replace(/ /g, '').length < 3) return 'Transit name has to be at least 3 characters.'
  return false
}

export const validateAddress = (address) => {
  if (address === null) return false
  if (containsProfane(address)) return 'Text includes profane words.'
  if (isEmpty(address)) return 'Address cannot be empty.'
  if (address.replace(/ /g, '').length < 3) return 'Address has to be at least 3 characters.'
  if (checkLength(address, 80)) return 'Maximum of 55 characters.'
  return false
}

export const validateAddress2 = (address) => {
  if (address === null) return false
  if (containsProfane(address)) return 'Text includes profane words.'
  if (checkLength(address, 80)) return 'Maximum of 55 characters.'
  return false
}

export const validateSqFootage = (SqFootage) => {
  if (SqFootage === null) return false
  if (SqFootage.length === 0) return 'Square Footage cannot be empty.'
  if (SqFootage.length > 25) return 'Maximum of 25 digits.'

  if (SqFootage > 1000000) return 'Square Footage has to be under 1000000.'
  if (isNaN(SqFootage)) return 'Type only number'
  return false
}

export const validateImageUrl = (url) => {
  if (url.length > 0) {
    if (!isLink(url)) return 'Invalid URL. It has to be https or http format.'
  }
  return false
}

export const validateJobID = (jobID) => {
  if (!jobID) return 'Job ID cannot be empty'
  if (checkLength(jobID, 45)) return 'Maximum of 45 characters'
  return false
}

export const validateLocationName = (locationName) => {
  if (!locationName) return 'Location Name cannot be empty'
  if (checkLength(locationName, 255)) return 'Maximum of 255 characters'
  return false
}

export const validateTransitID = (transitID) => {
  if (!transitID) return `${words.transitId} cannot be empty`
  if (checkLength(transitID, 45)) return 'Maximum of 45 characters'
  return false
}

export const validateCity = (cityName) => {
  if (!cityName) return 'City Name cannot be empty'
  if (checkLength(cityName, 45)) return 'Maximum of 45 characters'
  return false
}

export const validatePostalCode = (postalCode) => {
  if (!postalCode) return 'Postal Code cannot be empty'
  if (postalCode.length !== 6) return 'Postal Code must be 6 characters'
  return false
}

export const validateFMZ = (FMZ) => {
  if (checkLength(FMZ, 29)) return 'Maximum of 29 characters'
  return false
}

export const validateSecurityAccess = (securityAccess) => {
  if (checkLength(securityAccess, 255)) return 'Maximum of 255 characters'
  return false
}

export const validateUnitNumber = (unitNumber) => {
  if (checkLength(unitNumber, 15)) return 'Maximum of 15 characters'
  return false
}

export const validateProvince = (province) => {
  if (!province) return 'Select a province'
  return false
}

export const validateAutocompleteBuildingName = (value) => {
  if (!value) return 'Search and select a building name'
  return false
}

export const validateJobTitle = (jobTitle) => {
  if (!jobTitle) return 'Select a job title'
  return false
}

export const validateClientName = async (clientName) => {
  if (!clientName) return 'Client Name cannot be empty'
  if (checkLength(clientName, 45)) return 'Maximum of 45 characters'
  const isClientNameDuplicated = await duplicateCheckClientName(clientName)
  if (isClientNameDuplicated) return 'The Client Name already exists'
  return false
}

export const duplicateCheckClientName = async (clientName) => {
  const data = { searchInput: clientName }
  const duplicateSearchResult = await ApiService().searchAccountByName(data)
  return duplicateSearchResult.length > 0 && duplicateSearchResult[0].name === clientName
}

export const validateEndCustomer = (endCustomer) => {
  if (!endCustomer) return 'End Customer cannot be empty'
  if (checkLength(endCustomer, 50)) return 'Maximum of 50 characters.'

  return false
}

export const validateClientSearch = (client) => {
  if (!client) return 'Client cannot be empty'
  return false
}

export const validateLocationSearch = (location) => {
  if (!location) return 'Location cannot be empty'
  return false
}

export const validateServiceName = async (serviceName, serviceTypeId) => {
  if (!serviceName) return 'Service Name cannot be empty'
  if (checkLength(serviceName, 100)) return 'Maximum of 100 characters.'
  const isServiceNameDuplicated = await duplicateCheckServiceName(serviceName, serviceTypeId)
  if (isServiceNameDuplicated) return 'The Service Name already exists'
  return false
}

export const validateServiceTitle = async (serviceName) => {
  if (checkLength(serviceName, 100)) return 'Maximum of 50 characters.'
  return false
}

export const duplicateCheckServiceName = async (serviceName, typeId) => {
  const data = { name: serviceName, typeId }
  const duplicateSearchResult = await ApiService().getServiceByNameAndType(data)
  return duplicateSearchResult && duplicateSearchResult.length > 0 && duplicateSearchResult[0].name === serviceName
}

export const validateOrganizationName = (organizationName) => {
  if (!organizationName) return 'Organization Name cannot be empty'
  return false
}

export const validateApproverName = (approver) => {
  if (!approver) return 'Please select an approver for your submission'
  return false
}

export const validateEffectiveDate = (date) => {
  if (!date) return 'Effective Date cannot be empty'
  return false
}

export const validateRejectionReason = (reason) => {
  if (!reason) return 'Reason for rejection cannot be empty'
  if (checkLength(reason, 255)) return 'Maximum of 255 characters.'
  if (containsProfane(reason)) return 'Text includes profane words.'
  return false
}

const textBasicCheck = (label, input, required, maxLength) => {
  if (required && !input) return `${label} cannot be empty`
  if (checkLength(input, maxLength)) return `Maximum of ${maxLength} characters.`
  if (containsProfane(input)) return 'Text includes profane words.'
  return false
}

const groupNameDuplicateCheck = async (groupName) => {
  const res = await ApiService().checkGroupNameDuplicate(groupName)
  return res.data.data
}

export const validateGroupName = async (groupName, edit, nameOriginal) => {
  if (groupName !== nameOriginal) {
    const duplicateCheck = await groupNameDuplicateCheck(groupName)
    if (duplicateCheck) return 'The group name already exists'
  }

  return textBasicCheck('Group Name', groupName, true, 50)
}

const resourceNameDuplicateCheck = async (resourceName) => {
  const searchResult = await ApiService().getAllResourcesList()
    .then((res) => {
      return res.data.data
    })

  return searchResult.find(resource => {
    return resource.name === resourceName
  })
}

export const validateResourceName = async (resourceName, originalName) => {
  if (resourceName !== originalName) {
    const duplicateCheck = await resourceNameDuplicateCheck(resourceName)
    if (duplicateCheck) return 'The group name already exists'
  }

  return textBasicCheck('Group Name', resourceName, true, 50)
}

export const validateRequiredDescription = (description) => {
  return textBasicCheck('Description', description, true, 255)
}

export const validateImportType = (importType) => {
  if (!importType) return 'Import Type cannot be empty'
  return false
}

export const validateFieldLabel = (fieldLabel) => {
  return textBasicCheck('Field Label', fieldLabel, true, 40)
}
